module.exports = __webpack_public_path__ + "img/lesson-arrow-right.84065702.svg";